/**
 * Sends a trackPageView to Snowplow.
 *
 * @param {string} path The path reported on.
 */
export function sendPageView() {
  window.dataLayer.push({event: 'virtualPageView'})
}

/**
 * Fires a tracking event for Snowplow.
 * When in debugging mode (DEBUG === true), prints out the tracking event.
 * Otherwise, pushes the event to the Google Tag Manager (GTM) dataLayer.
 * Once in there, GTM is configured to send the event to Snowplow.
 *
 * @param  {string} event          Name of the Snowplow event
 * @param  {string} eventCategory Category of the event
 * @param  {object} fields         Any number of other fiends {'field_name': 'value', ...}
 */
export function trackEventSP(event, eventCategory, fields) {
  const eventData = {event: event, event_category: eventCategory, ...fields}
  if (window.DEBUG) {
    console.log('trackEventSP', eventData)
  } else {
    window.dataLayer.push(eventData)
  }
}

// look for data-track-event-sp on target node or nearby ancestor, return the value of that
// attribute if found, otherwise null
function identifySpEvent(ev) {
  let node = ev.target

  for (let i = 0; i < 3; i++) {
    if (node?.dataset?.trackEventSp) {
      return node.dataset.trackEventSp
    } else if (node.parentNode) {
      node = node.parentNode
    }
  }

  return null
}

// trigger an event based on the value of data-track-event-sp
function trackEventSpFromAttr(attrValue) {
  const split = attrValue.split('*')

  if (split.length > 1) {
    const eventName = split.shift(), eventCat = split.shift(), fields = {}
    split.forEach(fieldAttr => {
      const [fieldName, fieldVal] = fieldAttr.split("=")
      fields[fieldName] = fieldVal
    })

    trackEventSP(eventName, eventCat, fields)
  }
}

/**
 * For Snowplow Tracking
 * Checks to see if any element which has been clicked on contains an
 * attribute of:
 *
 * data-track-event-sp
 *
 * If so, it will look for the value in the following format:
 *
 * event*event_category*field_name=value*field_name_2=value_2
 *
 * @example
 * <a href="/foo" data-track-event-sp="event*event_category*field_name=value*field_name_2=value_2">foo</a>
 */
export function listenForTrackEvents() {
  document.body.addEventListener("click", ev => {
    const spAttrs = identifySpEvent(ev)
    if (spAttrs) {
      trackEventSpFromAttr(spAttrs)
    }
  })
}
